import { render } from "./doctorprofile-settings.vue?vue&type=template&id=44b12e0a"
import script from "./doctorprofile-settings.vue?vue&type=script&lang=js"
export * from "./doctorprofile-settings.vue?vue&type=script&lang=js"

import "./doctorprofile-settings.vue?vue&type=style&index=0&id=44b12e0a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__